var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDashedCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3V6C33.945 6 42 14.055 42 24C42 33.945 33.945 42 24 42V45C35.595 45 45 35.595 45 24C45 12.405 35.595 3 24 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.36 37.71L10.425 40.005C12.27 41.565 14.385 42.81 16.695 43.665L17.715 40.845C15.735 40.11 13.92 39.045 12.345 37.71H12.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28496 27L3.32996 27.615C3.74996 30.06 4.58996 32.355 5.78996 34.425L8.38496 33C7.36496 31.23 6.64496 29.085 6.28496 27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38496 15L5.78996 13.5C4.60496 15.57 3.76496 17.94 3.32996 20.385L6.28496 20.91C6.64496 18.825 7.36496 16.785 8.38496 15.015V15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 7.14L16.71 4.32C14.4 5.175 12.285 6.42 10.44 7.98L12.375 10.275C13.95 8.94 15.765 7.875 17.745 7.14H17.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18V15H25.5V10.5H22.5V15H19.5C17.8455 15 16.5 16.3455 16.5 18V22.5C16.5 24.1545 17.8455 25.5 19.5 25.5H28.5V30H16.5V33H22.5V37.5H25.5V33H28.5C30.1545 33 31.5 31.6537 31.5 30V25.5C31.5 23.8455 30.1545 22.5 28.5 22.5H19.5V18H31.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashedCurrency);
export default __webpack_public_path__ + "static/media/ic-dashed-currency.38d623952a85dbadcecec4884ee06966.svg";
export { ForwardRef as ReactComponent };